import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from 'src/app/shared/components/base/base-page.component';
import { Router } from '@angular/router';
import { BusinessSubscriptionService } from 'src/app/core/services/domain/business-subscription.service';
import { BusinessContextService } from 'src/app/core/services/domain/business-context.service';
import { AuthClientService } from 'src/app/core/services/auth/auth-client.service';

@Component({
  selector: 'app-pricing-page',
  templateUrl: './pricing-page.component.html',
  styleUrls: ['./pricing-page.component.scss']
})
export class PricingPageComponent extends BasePageComponent implements OnInit {
  constructor(private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.router.navigateByUrl(this.routeUtilities.routes.application.subscriptions.getNavigateUrl());
  }

  onGetStartedNowClicked(): void {
    this.router.navigateByUrl(this.routeUtilities.routes.application.subscriptions.getNavigateUrl());
  }
}
